import { AddAcquirerPhysicalButton } from "src/app/features/Acquirer/components/buttons/AddPhysicalButton";
import { AddAcquirerVirtualButton } from "src/app/features/Acquirer/components/buttons/AddVirtualButton";
import { AcquirersSearchForm } from "src/app/features/Acquirer/components/forms/AcquirersSearchForm";
import type { AcquirerList } from "src/app/features/Acquirer/types/AcquirerList";
import { PageLayout } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components/PageTitle";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { Permissions } from "../../../../core/router/config/Permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";
import type { Entity } from "../../../../core/types/fe";
import { AcquirersTable } from "../components/tables/AcquirersTable";

const getAcquirerCopyRedirectUrl = (copiedItem: Entity): string => {
    return `${BASE_PATH}/${ResourceName.ACQUIRER}/virtual/${FORM_ACTION.EDIT}/${copiedItem.id}`;
};

const shouldShowCopyAction = (selectedItem: AcquirerList | undefined, actionType: Actions.COPY | Actions.FORM_COPY): boolean => {
    if (!selectedItem) {
        return actionType === Actions.COPY;
    }

    return selectedItem.physical ? actionType === Actions.FORM_COPY : actionType === Actions.COPY;
};

export const AcquirersPage = () => {
    const table = <AcquirersTable />;
    const searchForm = <AcquirersSearchForm />;
    const hasAccess = canAccess(ResourceName.ACQUIRER, "canRead");

    return (
        <PageLayout name="acquirers_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.acquirer" />
                    <ResourceManager<AcquirerList>
                        useDataGroup
                        searchForm={searchForm}
                        dataMapperKey="acquirersTableData"
                        resource={ResourceName.ACQUIRER}
                        table={table}
                        actions={[Actions.DELETE, Actions.EXPORT, Actions.COPY, Actions.FORM_COPY]}
                        shouldShowCopyAction={shouldShowCopyAction}
                        getCopyRedirectUrl={getAcquirerCopyRedirectUrl}
                        customActions={[
                            {
                                action: <AddAcquirerPhysicalButton />,
                                permission: Permissions.ADD,
                            },
                            {
                                action: <AddAcquirerVirtualButton />,
                                permission: Permissions.VIRTUAL,
                            },
                        ]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
